// generated from 5 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const pushUnsubscribedSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("push_unsubscribed_since_filter"),
  comparison_key: z.enum(["3", "5", "6"]),
  display_name: z.string(),
  // undefined: 4 (80.00%), defined 1 (20.00%)
  raw_value: z.union([common.date, z.int()]).optional(),
  value: z.union([common.date, z.int()]),
  varies_by_app_group: z.literal(false),
});
